<template>
  <div
    :class="[
      !score
        ? 'bg-gray-100 text-gray-800'
        : score >= 8
        ? 'bg-green-100 text-green-800'
        : score >= 4
        ? 'bg-yellow-100 text-yellow-800'
        : 'bg-red-100 text-red-800',
      '  inline-flex items-baseline rounded-full px-2.5 py-0.5 text-sm font-medium md:mt-2 lg:mt-0 ',
      ' ',
    ]"
  >
    {{ formatValue(score) || "N/A" }}
  </div>
</template>

<script setup lang="ts">
const props = defineProps(["score"]);

function formatValue(val) {
  if (typeof val === "number") {
    let v = Math.round((val + Number.EPSILON) * 10) / 10;
    return v.toFixed(1);
  }
  return val;
}
</script>
